import React from 'react';

export default class Subject extends React.Component {

    render(){
		return (
            <li className="list-group-item">
                <label className="lb-md">{ this.props.name }: <small>{this.props.topics}</small></label>
                <button className="btn btn-default float-right" type="button" onClick={ () => this.props.sendViewRequest(this.props.id) }>Anzeigen</button>
            </li>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/Subject.js